import React from 'react';

interface Iprops {
  pClassName?: string
  data?: {
    title?: string
    list?: Array<{
      title?: string
      subTitle?: string
      content?: string
      noTop?: boolean
    }>
  }
}

function PrivacyCard(props: Iprops) {

  const {
    data,
    pClassName
  } = props

  return (
    <div className={`${pClassName}`}>
      <div className=' mt-3 font-semibold font-Poppins text-xl'>{data?.title}</div>
      {
        data?.list?.map(({title, subTitle, content, noTop}) => {
          return (
            <>
              { title ? <div  className=' mt-3 font-semibold font-Poppins text-base'>{title}</div> : '' }
              <div className={` font-Poppins text-base ${noTop ? '' : 'mt-3'}`}>
                <i className=' not-italic font-semibold'>{subTitle}</i>
                <i className=' not-italic font-[400]' dangerouslySetInnerHTML={{__html: content || ''}} />
              </div>
            </>
          )
        })
      }
    </div>
  );
}

export default PrivacyCard;



